import { render, staticRenderFns } from "./DevButton.vue?vue&type=template&id=e6074224&"
import script from "./DevButton.vue?vue&type=script&lang=js&"
export * from "./DevButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6074224')) {
      api.createRecord('e6074224', component.options)
    } else {
      api.reload('e6074224', component.options)
    }
    module.hot.accept("./DevButton.vue?vue&type=template&id=e6074224&", function () {
      api.rerender('e6074224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/dev/DevButton.vue"
export default component.exports